var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2042 9.50244V9.40244H19.1042H18.2227H18.1227V9.50244V10.2651V10.3651H18.2227H19.1042H19.2042V10.2651V9.50244Z",
    fill: "#FF0990",
    stroke: "#FF0990",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8643 9.50244V9.40244H20.7643H19.8828H19.7828V9.50244V10.2651V10.3651H19.8828H20.7643H20.8643V10.2651V9.50244Z",
    fill: "#FF0990",
    stroke: "#B4B4B4",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 1V0.9H27H5.18493H5.08493V1V7.70333H1H0.9V7.80333V27V27.1H1H22.8151H22.9151V27V20.288H27H27.1V20.188V1ZM22.8151 7.70333H6.14863V5.27733H26.0452V19.2473H22.9151V7.80333V7.70333H22.8151ZM26.0452 1.94067V4.23667H6.14863V1.94067H26.0452ZM21.8514 8.744V11.0313H1.95479V8.744H21.8514ZM1.95479 26.0593V12.072H21.8514V26.0593H1.95479Z",
    fill: "#FF0990",
    stroke: "#FF0990",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3956 2.69824V2.59824H23.2956H22.4141H22.3141V2.69824V3.46091V3.56091H22.4141H23.2956H23.3956V3.46091V2.69824Z",
    fill: "#FF0990",
    stroke: "#FF0990",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0596 2.69824V2.59824H24.9596H24.0781H23.9781V2.69824V3.46091V3.56091H24.0781H24.9596H25.0596V3.46091V2.69824Z",
    fill: "#FF0990",
    stroke: "#B4B4B4",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0875 23.9668V24.0668H5.1875H18.6505H18.7505V23.9668V14.2168V14.1168H18.6505H5.1875H5.0875V14.2168V23.9668ZM6.1512 15.1575H17.6868V23.0261H6.1512V15.1575Z",
    fill: "#FF0990",
    stroke: "#FF0990",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0133 22.3717V22.5424L10.1622 22.459L15.6382 19.391L15.7937 19.3038L15.6383 19.2165L10.1623 16.1399L10.0133 16.0562V16.2271V22.3717ZM11.0681 17.8539L13.6484 19.3035L11.0681 20.7453V17.8539Z",
    fill: "#FF0990",
    stroke: "#FF0990",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPink);
export default __webpack_public_path__ + "static/media/video-pink.0c96177ad74fb2d797cc8aabdb8f72d1.svg";
export { ForwardRef as ReactComponent };